module.exports = __webpack_public_path__ + "img/1-1.f9c950c7.jpg";